// Shows which pathway(s) a client is on, using the same icons and gradients as the app's
// PathwayDropdown (Journey-App-Public-UI). Flags come from GET /user/id/{id} -> smokingInformation.
const PATHWAYS = [
    { key: 'isOnCigarettePathway', label: 'Smoking', icon: '/pathway/smoking.svg', className: 'pathwayBadge--smoking' },
    { key: 'isOnVapingPathway', label: 'Vaping', icon: '/pathway/vaping.svg', className: 'pathwayBadge--vaping' }
];

const PathwayBadges = ({ smokingInformation }) => {
    if (!smokingInformation) return null;

    const active = PATHWAYS.filter(p => smokingInformation[p.key]);

    return (
        <span className="pathwayBadges" title={active.length ? `Active pathways: ${active.map(p => p.label).join(' & ')}` : 'No active pathway'}>
            {active.map(p => (
                <span key={p.key} className={`pathwayBadge ${p.className}`}>
                    <img src={p.icon} alt="" className="pathwayBadge__icon" />
                    {p.label}
                </span>
            ))}
            {active.length === 0 && <span className="pathwayBadge pathwayBadge--none">No pathway</span>}
        </span>
    );
};

export default PathwayBadges;
